/* eslint-disable import/prefer-default-export */

export const setToken = (token) => {
  localStorage.setItem('access_token', token);
};
